import { render, staticRenderFns } from "./ProductDelete.vue?vue&type=template&id=c250d6f2"
import script from "./ProductDelete.vue?vue&type=script&lang=js"
export * from "./ProductDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports